export const SET_HIDE_UNUSED_GROUPS = 'SET_HIDE_UNUSED_GROUPS';
